import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Object Json */
import { isEmpty, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';

import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import {
  TASK_STAT_NEW,
  TASK_STAT_IN_PROGRESS,
  TASK_STAT_PENDING,
  TASK_STAT_SOLVED,
  TASK_STAT_CLOSED
} from '../../lib/components/Preference';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const CHANGE = "CHANGE";
const WKEY = "TASK_CHANGE";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const taksStatus = {
  TASK_STAT_NEW: {
    name: 'New',
    value: TASK_STAT_NEW
  },
  TASK_STAT_IN_PROGRESS: {
    name: 'In progress',
    value: TASK_STAT_IN_PROGRESS
  },
  TASK_STAT_PENDING: {
    name: 'Pending',
    value: TASK_STAT_PENDING
  },
  TASK_STAT_SOLVED: {
    name: 'Solved',
    value: TASK_STAT_SOLVED
  },
  TASK_STAT_CLOSED: {
    name: 'Closed',
    value: TASK_STAT_CLOSED
  }
}

// validation for string
function statusValidation() {
  let dropdownItem = [];
  for (let key in taksStatus) {
    if (taksStatus.hasOwnProperty(key)) {
      dropdownItem.push(
        {
          type: 'integer',
          enum: [
            taksStatus[key].value
          ],
          title: taksStatus[key].name
        }
      )
    }
  }
  return dropdownItem;
}

function schema() {
  return {
    "definitions": {
      "Tasks": {
        "title": "Status Task",
        "type": "integer",
        "anyOf": statusValidation()
      }
    },
    type: "object",
    required: ["status_value"],
    properties: {
      status_value: {
        "$ref": "#/definitions/Tasks",
        "title": "Status Task"
      },
    }
  }
};

const uiSchema = {
};

class TaskEdit extends Component {
  constructor(props) {
    super(props);
    const taskId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      loading: true,
      taskId
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { taskId } = _state;
    if (isNone(taskId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    const domains = domain(_props)
    const isTenant = domainIsTenant.isTenant;
    // callback global
    setCallbackGlobal(_props)
    // Get task
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: '/service/web/task/get/id/' + taskId },
        wcallback: {
          started: function (id) {
            _props.showLoading();
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              // _this.setState({ loading: false })
              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
              if (responseResult === Result.SUCCESS) {

              } else {
              }
            }
          }
        },
        wreducer: {
          rparse: function (id, result, rpayload) {
            let item = {};
            let task = safeDeepGet(rpayload, ['data']);
            let status_value = safeDeepGetWithType(task, ['status_value'], -1);
            item.status_value = status_value
            item.status = safeDeepGetWithType(task, ['status'], '');
            _this.setState({ loading: false, status_value })
            return item;
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [CHANGE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/task/change/status"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  // Magic to refresh routes
                  if (isTenant) {
                    _props.history.push('..' + S + '..')
                    _props.history.push('..' + S + domains + S + '_task_list_')
                    _props.showSingleNotification({ message: 'Kelola tugas berhasil', level: 'success' });
                  } else {
                    _props.history.push('..' + S + '_task_list_')
                    _props.showSingleNotification({ message: 'Kelola tugas berhasil', level: 'success' });
                  }
                  return;
                }
              } else if (result.code === Result.HTTP.FORBIDDEN) {
                _this.setState({
                  loading: false
                })
                _props.showSingleNotification({
                  message: 'Akses ditolak (aksi ini hanya dapat dilakukan oleh role lebih tinggi)',
                  position: 'tr', level: 'error'
                });
                return;
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Kelola tugas gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { taskId } = _state;
    if (isNone(taskId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const id = safeDeepGetWithType(_state, ['taskId'], '');
    if (id === '') {
      return;
    }
    const status = safeDeepGetWithType(event, ['formData', 'status_value'], -1);
    const currStatus = safeDeepGetWithType(_state, ['status_value'], -1);
    if (status === currStatus) {
      _props.showSingleNotification({ message: 'Tidak ada perubahan', position: 'tr', level: 'warning' });
      return;
    }
    _props.wSingleRequestCall({
      id: CHANGE,
      body: {
        id,
        status
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dataToShow = {};
    let item = safeDeepGet(_props, ['item'], {});
    if (!isEmpty(item)) {
      dataToShow = item;
    }
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    if (!isEmpty(dataToShow)) {
      return (
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Kelola Tugas' subTitle='Formulir Kelola Tugas' />
            <div className="io-container mt-12">
              <IoteraForm
                schema={schema()}
                uiSchema={uiSchema}
                formData={dataToShow}
                onSubmit={_this.handleSubmit}
              >
                <div className="button-right">
                  <Button variant="outlined" type="button" size="large"
                    style={{ minWidth: '0%' }} onClick={(e) => _this.goTo('..' + S + '_task_list_')} >Batal</Button>
                  <Button variant="contained" size="large" color="primary" type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                </div>
              </IoteraForm>
            </div>
          </div>
        </Loader>
      );
    } else {
      return (
        <div className="view">
          <SubViewHeader title='Kelola Tugas' subTitle='Formulir Kelola Tugas' />
          <div className="io-container mt-12">
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = function (state, ownProps) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state)
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaskEdit));